<template>
  <v-flex row align-center class="message-bar-btn" @click="handleOnClick()">
    <span v-if="dividerPosition==='left' || dividerPosition==='both'" class="mr-1 message-bar-divider-line vertical-divider-line vertical-divider-line-white"></span>
    <span class="message-bar-btn-content" :class="btnSelected && 'message-bar-btn-content-selected'">
      <v-icon v-if="iconCondition || iconCondition===undefined" class="message-bar-icon message-bar-icon-no-errors">{{ defaultIcon }}</v-icon>
      <v-icon v-else class="message-bar-icon message-bar-icon-errors">{{ secondaryIcon }}</v-icon>
      <span class="message-bar-title" v-if="showText">
        {{ btnTitle }}
      </span>
    </span>
    <span v-if="dividerPosition==='right' || dividerPosition==='both'" class="message-bar-divider-line vertical-divider-line vertical-divider-line-white"></span>
  </v-flex>
</template>

<script>
import '../../../style/_variables.scss'
export default {
  name: 'MessageBarBtn',
  props: {
    handleOnClick: { default: undefined },
    btnTitle: { default: undefined },
    showText: { default: true, type: Boolean },
    defaultIcon: { default: undefined },
    secondaryIcon: { default: undefined },
    iconCondition: { default: undefined },
    dividerPosition: { default: undefined },
    btnSelected: { default: undefined, type: Boolean }
  },
  computed: () => {
    console.log('iconCondition:', this.iconCondition)
  }
}
</script>

<style lang="scss" scoped>
.message-bar {
  &-btn {
    cursor: pointer;
    padding: 0 2px;
    max-width: fit-content;
    &-content {
      border-radius: 5px;
      padding: 2px;
      margin: 0 2px;
      &:hover {
        background-color: $light-blue-400;
      }
      &-selected {
        background-color: $light-blue-400;
      }
    }
  }
  &-title {
    padding: 0 5px;
    font-weight: bold;
  }
  &-icon {
    color: $black-900;
    font-size: 16px;
    &-errors {
      color: $error !important;
    }
    &-no-errors {
      color: $success !important;
    }
  }
  &-divider-line {
    height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/MessageBarBtn.vue